<template>
  <el-dialog
    title="业绩金额分段提成"
    :visible.sync="visible"
    width="300px"
    append-to-body
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      :rules="rules"
      :model="form"
      label-width="90px">
      <el-form-item
        label="比例:"
        prop="rate">
        <el-input-number
          v-model="form.rate"
          :min="0.1"
          :precision="1"
          :step="0.1"
          :max="50"></el-input-number>%
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'PartnerRateModal',
  components: {},
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      index: -1,
      form: {
        rate: 0.1
      },
      rules: {
        rate: [
          { required: true, message: '请上传卡片', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.callback && this.callback(this.form.rate, this.index)
          this.toggleModal(false)
        }
      })
    },
    init({ index, value }) {
      this.index = index
      this.form.rate = value
      this.toggleModal(true)
    }
  }
}
</script>
